<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="() => ({})"
    max-width="900px"
    @closed="$emit('closed')"
  >
    <template #title-text>
      {{ title }}
    </template>

    <template #default>
      <LKPublicationsFormdataReport
        :params="params"
        :report-code="reportCode"
      />
    </template>

    <template #footer>
      <div />
    </template>
  </BModalForm>
</template>

<script>
import BModalForm from '@/components/modals/BModalForm.vue'
import LKPublicationsFormdataReport from '@/views/LKPublications/formdata/LKPublicationsFormdataReport.vue'


export default {
  name: 'PublicationStorageModal',
  components: {
    BModalForm,
    LKPublicationsFormdataReport,
  },
  inheritAttrs: false,
  props: {
    reportCode: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  },
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
  },
}
</script>
